import LinkedInLeadsApiSettingsTab from './linked-in-leads-api-settings';

export default LinkedInLeadsApiSettingsTab;
